export const isDotOlderThanThreeYears = (dotCode: string) => {
  const currentYear = parseInt(
    new Date().getFullYear().toString().slice(-2),
    10
  );
  const dotYear = parseInt(dotCode.slice(-2), 10); // extract last two digits from dot

  return currentYear - dotYear >= 3;
};
